(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/util.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/util.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const formatDate = (day, month, year) => "".concat(year, "-").concat(month < 10 ? '0' : '').concat(month, "-").concat(day < 10 ? '0' : '').concat(day);
const isNextYear = (day, month) => formatDate(day, month, new Date(Date.now()).getFullYear()) < svs.utils.date.SimpleDate(new Date(Date.now()));
svs.tickets_giftshop.gift.giftform.date_selector.components.util = {
  mapMonthByNumber: month => ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'][month - 1],
  getMonth: date => parseInt(date === null || date === void 0 ? void 0 : date.split('-')[1], 10) || new Date().getMonth(),
  getYear: date => parseInt(date === null || date === void 0 ? void 0 : date.split('-')[0], 10) || new Date().getFullYear(),
  isLeapYear: year => new Date(year, 1, 29).getDate() === 29,
  aggregateDateData: function (dateData) {
    let whitelist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return Object.keys(dateData).reduce((list, month) => {
      Object.keys(dateData[month]).forEach(day => {
        let names = dateData[month][day];
        if (whitelist.length) {
          names = names.filter(name => whitelist.includes(name));
        }
        if (!names.length) {
          return;
        }
        list.push({
          date: "".concat(month, "-").concat(day),
          names: Object.values(dateData[month][day])
        });
      });
      return list;
    }, []);
  },
  sortDateData: function () {
    let dateData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return dateData.sort((a, b) => {
      const thisYear = new Date(Date.now()).getFullYear();
      const _a$date$split = a.date.split('-'),
        _a$date$split2 = _slicedToArray(_a$date$split, 2),
        month = _a$date$split2[0],
        day = _a$date$split2[1];
      const date = new Date(isNextYear(day, month) ? thisYear + 1 : thisYear, month - 1, day, 12);
      const _b$date$split = b.date.split('-'),
        _b$date$split2 = _slicedToArray(_b$date$split, 2),
        nextMonth = _b$date$split2[0],
        nextDay = _b$date$split2[1];
      const nextDate = new Date(isNextYear(nextDay, nextMonth) ? thisYear + 1 : thisYear, nextMonth - 1, nextDay, 12);
      return date - nextDate;
    });
  },
  isNextYear,
  formatDate
};

 })(window);